import { useMutation, useQuery } from "@tanstack/react-query";

import type { AxiosError, AxiosResponse } from "axios";

import type { NotificationMethodRequest } from "@/entities/notification/api";
import { useMutate } from "@/shared/hooks";

import type { UpdatePasswordRequest, UpdateUsernameRequest } from "./api.dto";
import { useApi } from "@/shared/api";
import { useSessionStore } from "@/entities/session";

export const useMe = () => {
  const { api } = useApi();
  const { updateUser } = useSessionStore();

  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      const { data } = await api.get("/profile/me");
      updateUser(data);
      return data;
    },
  });
};

export const useSetNotificationMethod = () => {
  const { mutationFn, onSuccess, onError } = useMutate({
    method: "put",
    url: "/profile/notification-method",
    toast: {
      success: {
        description: "Метод уведомлений изменён.",
      },
    },
  });

  return useMutation<
    AxiosResponse,
    AxiosError,
    NotificationMethodRequest,
    Response
  >({
    mutationKey: ["updateUsername"],
    mutationFn,
    onSuccess,
    onError,
  });
};

export const useUpdateUsername = () => {
  const { mutationFn, onSuccess, onError } = useMutate({
    method: "put",
    url: "/profile/username",
    toast: {
      success: {
        description: "Имя пользователя изменено.",
      },
    },
  });

  return useMutation<AxiosResponse, AxiosError, UpdateUsernameRequest>({
    mutationKey: ["updateUsername"],
    mutationFn,
    onSuccess,
    onError,
  });
};

export const useUpdatePassword = () => {
  const { mutationFn, onSuccess, onError } = useMutate({
    method: "put",
    url: "/profile/change-password",
    toast: {
      success: {
        description: "Пароль изменён.",
      },
    },
  });

  return useMutation<AxiosResponse, AxiosError, UpdatePasswordRequest>({
    mutationKey: ["updatePassword"],
    mutationFn,
    onSuccess,
    onError,
  });
};
